import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "lss-page" }
const _hoisted_2 = { class: "lss-bar" }
const _hoisted_3 = { class: "lss-body" }
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 1,
  class: "lss-empty"
}

import { onBeforeUnmount, onMounted, ref } from 'vue'
import { ltcsScheduleProbeApi } from '@/services/api'


export default /*@__PURE__*/_defineComponent({
  __name: 'LtcsScheduleScreenPage',
  setup(__props) {

const frameUrl = ref('')
const stateText = ref('연결 중')
let timer: ReturnType<typeof setInterval> | null = null
let busy = false

const tick = async () => {
  if (busy) return
  busy = true
  try {
    const res = await ltcsScheduleProbeApi.getScreen()
    const blob = res.data as Blob
    if (res.status === 200 && blob && blob.size > 0) {
      const url = URL.createObjectURL(blob)
      if (frameUrl.value) URL.revokeObjectURL(frameUrl.value)
      frameUrl.value = url
      stateText.value = '실시간'
    } else {
      stateText.value = '브라우저 대기 중'
    }
  } catch {
    stateText.value = '연결 실패'
  } finally {
    busy = false
  }
}

onMounted(() => {
  tick()
  timer = setInterval(tick, 900)
})

onBeforeUnmount(() => {
  if (timer) clearInterval(timer)
  if (frameUrl.value) URL.revokeObjectURL(frameUrl.value)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("span", { class: "lss-title" }, "일정계획 크롤링 화면", -1)),
      _createElementVNode("span", {
        class: _normalizeClass(["lss-state", { live: !!frameUrl.value }])
      }, _toDisplayString(stateText.value), 3)
    ]),
    _createElementVNode("div", _hoisted_3, [
      (frameUrl.value)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            class: "lss-img",
            src: frameUrl.value,
            alt: "크롤링 브라우저 화면"
          }, null, 8, _hoisted_4))
        : (_openBlock(), _createElementBlock("p", _hoisted_5, "브라우저 화면을 기다리는 중…"))
    ])
  ]))
}
}

})